export interface ConsoleStubPageProps {
  title: string;
  body: string;
}

export function ConsoleStubPage({ title, body }: ConsoleStubPageProps) {
  return (
    <div className="console-page">
      <div className="console-page-head">
        <h1 className="console-page-title">
          {title} <span className="badge badge--mock">Coming soon</span>
        </h1>
        <p className="console-page-sub">{body}</p>
      </div>
    </div>
  );
}
